import { Link } from 'react-router-dom';
import { Flex } from 'atoms';
import { SVG } from 'utils';

export const SideBarMenus = [
	{
		label: <Link to="/dashboard">Dashboard</Link>,
		key: 'dashboard',
		icon: <SVG.DashboardIcons width="20px" />,
		module: 'dashboard',
	},
	{
		key: 'approval_entities',
		label: <Link to="/approvals">Approvals</Link>,
		linkto: '/approvals',
		icon: <SVG.ApprovalsSVG width="20px" />,
		allowedgroups: [],
		children: [
			// {
			// 	label: (
			// 		<Flex alignItems="center">
			// 			<SVG.AdhocRequestIcon width="16px" />
			// 			<Link to="/approvals/ad-hoc-request">Ad-Hoc Request</Link>
			// 		</Flex>
			// 	),
			// 	key: 'approval-ad-hoc-request',
			// 	v2Only: true,
			// },
			{
				label: (
					<Flex alignItems="center">
						<SVG.ClientsIcon width="16px" />
						<Link to="/approvals/client-contract">Client Contract</Link>
					</Flex>
				),
				key: 'approval-client-contract',
				v2Only: true,
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.ClientsIcon width="16px" />
						<Link to="/approvals/client-invoice-edit-approval">
							Client Invoice Edit Approval
						</Link>
					</Flex>
				),
				key: 'approval-client-invoice-edit-approval',
				v2Only: true,
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.UserManagementIcons width="16px" />
						<Link to="/approvals/vendor-contract">Vendor Contract</Link>
					</Flex>
				),
				key: 'approval-vendor-contract',
				v2Only: true,
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.UserManagementIcons width="16px" />
						<Link to="/approvals/vendor-bank-details">Vendor Bank Details</Link>
					</Flex>
				),
				key: 'approval-vendor-bank-details',
				v2Only: true,
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.UserManagementIcons width="16px" />
						<Link to="/approvals/driver">Driver Approval</Link>
					</Flex>
				),
				key: 'approval-driver',
				v2Only: true,
				includedUserTypes: ['control_tower', 'admin'],
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.VehiclesIcon width="16px" />
						<Link to="/approvals/vehicle">Vehicle Approval</Link>
					</Flex>
				),
				key: 'approval-vehicle',
				v2Only: true,
				includedUserTypes: ['control_tower', 'admin'],
			},
			/* Vehicle replacement moved to trip level — approval entry hidden.
			{
				label: (
					<Flex alignItems="center">
						<SVG.VehiclesIcon width="16px" />
						<Link to="/approvals/vehicle-replacement">Vehicle Replacement</Link>
					</Flex>
				),
				key: 'approval-vehicle-replacement',
				v2Only: true,
			},
			*/
			{
				label: (
					<Flex alignItems="center">
						<SVG.TripsIcon width="16px" />
						<Link to="/approvals/trip-pod-approvals">Trip and POD Approvals</Link>
					</Flex>
				),
				key: 'approval-trip-pod-approvals',
				v2Only: true,
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.FinanceIcon width="16px" />
						<Link to="/approvals/invoice-edit-approval">Invoice Edit Approval</Link>
					</Flex>
				),
				key: 'approval-invoice-edit-approval',
				v2Only: true, // Only show as child in new UI
			},
		],
		module: 'approval_entities',
		oldUILink: true, // Flag to indicate parent link should only work in old UI
	},
	{
		// Separate menu item for Invoice Edit Approval in old UI only
		label: <Link to="/approvals/invoice-edit-approval">Invoice Edit Approval</Link>,
		key: 'invoice-edit-approval-old',
		linkto: '/approvals/invoice-edit-approval',
		icon: <SVG.FinanceIcon width="20px" />,
		module: 'approval_entities',
		oldUIOnly: true, // Only show in old UI
	},
	{
		label: <Link to="/airexpenses">Air Expenses</Link>,
		key: 'awb',
		linkto: '/airexpenses',
		icon: <SVG.AirIcons width="20px" />,
		module: 'awb',
	},
	{
		key: 'trips',
		label: 'Trips',
		icon: <SVG.TripsIcon width="20px" />,
		allowedgroups: [],
		children: [
			{
				label: (
					<Flex alignItems="center">
						<SVG.TripHistoryIcon width="16px" />
						<Link to="/trip-history">Trip History</Link>
					</Flex>
				),
				key: 'Trip-history',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.IntercityTripIcon width="16px" />
						<Link to="/trips/intercity">Intercity Trip List</Link>
					</Flex>
				),
				key: 'Intercity-Trip-list',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.IntracityTripIcon width="16px" />
						<Link to="/trips/intracity">Intracity Trip List</Link>
					</Flex>
				),
				key: 'Intracity-Trip-list',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.AdhocRequestIcon width="16px" />
						<Link to="/trips/adhoc-request">Adhoc Request</Link>
					</Flex>
				),
				key: 'Adhoc-Request',
			},
		],
		module: 'trip',
	},
	{
		key: 'vehicles',
		label: 'Vehicles',
		icon: <SVG.VehiclesIcon width="20px" />,
		allowedgroups: [],
		children: [
			{
				label: (
					<Flex alignItems="center">
						<SVG.VehiclesIcon width="16px" />
						<Link to="/vehicles">Vehicles List</Link>
					</Flex>
				),
				key: 'Vehicles-vehicle-list',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.VehiclesIcon width="16px" />
						<Link to="/vehicle-type">Vehicle Type</Link>
					</Flex>
				),
				key: 'Vehicles-vehicle-type',
				v2Only: true,
			},
		],
		module: 'vehicle',
	},
	{
		key: 'clients',
		label: 'Clients',
		icon: <SVG.ClientsIcon width="20px" />,
		allowedgroups: [],
		children: [
			{
				label: (
					<Flex alignItems="center">
						<SVG.ClientsIcon width="16px" />
						<Link to="/client-list">Client List</Link>
					</Flex>
				),
				key: 'Client-client-list',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.ClientsIcon width="16px" />
						<Link to="/projects">Project List</Link>
					</Flex>
				),
				key: 'Client-project-list',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.ClientsIcon width="16px" />
						<Link to="/client-contracts">Client Contract</Link>
					</Flex>
				),
				key: 'Client-contracts',
			},
			{
				label: (
					<Flex alignItems="center">
						<SVG.ClientsIcon width="16px" />
						<Link to="/client-invoices">Client Invoices</Link>
					</Flex>
				),
				key: 'Client-invoices',
				v2Only: true,
			},
		],
		module: 'client',
	},
	{
		key: 'vendor',
		label: 'Vendor',
		icon: <SVG.UserManagementIcons width="20px" />,
		allowedgroups: [],
		children: [
			{
				label: (
					<Flex>
						<SVG.UserManagementIcons width="16px" />
						<Link to="/vendor-list">Vendor List</Link>
					</Flex>
				),
				key: 'Vendor-vendor-list',
			},
			{
				label: (
					<Flex>
						<SVG.UserManagementIcons width="16px" />
						<Link to="/vendor-contracts">Vendor Contract</Link>
					</Flex>
				),
				key: 'Vendor-contracts',
			},
			{
				label: (
					<Flex>
						<SVG.UserManagementIcons width="16px" />
						<Link to="/vendor-invoices">Vendor Invoices</Link>
					</Flex>
				),
				key: 'vendor-bill',
			},
		],
		module: 'vendor',
	},
	{
		key: 'finance',
		label: 'Finance',
		icon: <SVG.FinanceIcon width="20px" />,
		children: [
			{
				label: <Link to="/finance/requests">Requests</Link>,
				key: 'finance-requests',
				linkto: '/finance/requests',
				icon: <SVG.RequestsIcon width="16px" />,
			},
			{
				label: <Link to="/finance/payments">Payments</Link>,
				key: 'finance-payments',
				linkto: '/finance/payments',
				icon: <SVG.PaymentsIcon width="16px" />,
			},
		],
		module: 'finance',
	},
	{
		key: 'control_tower',
		label: 'Control Tower',
		icon: <SVG.ControlTower width="20px" />,
		allowedgroups: [],
		children: [
			{
				label: (
					<Flex>
						<SVG.WhatsApp width="16px" />
						<Link to="/control-tower/whatsapp">WhatsApp</Link>
					</Flex>
				),
				key: 'control-tower-whatsapp',
			},
		],
		module: 'control_tower',
	},
	{
		label: <Link to="/business-units">Business Unit</Link>,
		key: 'business_unit',
		linkto: '/business-units',
		icon: <SVG.BusinessUnitIcon width="20px" />,
		module: 'business_unit',
	},
	{
		label: <Link to="/drivers">Driver</Link>,
		key: 'drivers',
		linkto: '/drivers',
		icon: <SVG.DriversIcon width="20px" />,
		module: 'driver',
	},
	{
		label: <Link to="/nodes">Node Management</Link>,
		key: 'node_management',
		linkto: '/nodes',
		icon: <SVG.NodeManagementIcon width="20px" />,
		module: 'node_management',
		v2Only: true,
	},
	{
		label: <Link to="/routes">Route Management</Link>,
		key: 'route_management',
		linkto: '/routes',
		icon: <SVG.RouteManagementIcon width="20px" />,
		module: 'route_management',
		v2Only: true,
	},
	{
		label: <Link to="/employees">Employee</Link>,
		key: 'users',
		linkto: '/employees',
		icon: <SVG.EmployeesIcon width="20px" />,
		module: 'employee',
	},
	{
		label: <Link to="/downloads">Downloads</Link>,
		key: 'download_task',
		linkto: '/downloads',
		icon: <SVG.DownloadIconSVG width="20px" />,
		module: 'download_task',
	},
	{
		label: <Link to="/lr">LR Management</Link>,
		key: 'lrmanagement',
		linkto: '/lr',
		icon: <SVG.ConsignmentNote width="20px" />,
		module: 'consignment_note',
	},
	{
		label: <Link to="/warehousing">Warehousing</Link>,
		key: 'warehousing',
		linkto: '/warehousing',
		icon: <SVG.WarehousingIcon width="20px" />,
		// Must match the backend resource_type (TDD §9), which is 'warehouse', not
		// 'warehousing' — getValidMenus filters on permissions.search.includes(module).
		module: 'warehouse',
		v2Only: true,
	},
	{
		label: <Link to="/temperature-dashboard">Temprature Dashboard</Link>,
		key: 'temperature_dashboard',
		linkto: '/temperature-dashboard',
		icon: <SVG.TemperatureDashboard width="20px" />,
		module: 'temperature_dashboard',
	},
];
